module.exports = __webpack_public_path__ + "static/media/logo_2x.0c2a40bb.png";